/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedAdminRouteRouteImport } from './routes/_authenticated/admin/route'
import { Route as AuthenticatedSitesIndexRouteImport } from './routes/_authenticated/sites/index'
import { Route as AuthenticatedSitesNewRouteImport } from './routes/_authenticated/sites/new'
import { Route as AuthenticatedAdminSystemRouteImport } from './routes/_authenticated/admin/system'
import { Route as AuthenticatedAdminMembersRouteImport } from './routes/_authenticated/admin/members'
import { Route as AuthenticatedAdminAuditRouteImport } from './routes/_authenticated/admin/audit'
import { Route as AuthenticatedSitesSiteIdRouteRouteImport } from './routes/_authenticated/sites/$siteId/route'
import { Route as AuthenticatedSitesSiteIdIndexRouteImport } from './routes/_authenticated/sites/$siteId/index'
import { Route as AuthenticatedSitesSiteIdInsightsRouteImport } from './routes/_authenticated/sites/$siteId/insights'
import { Route as AuthenticatedSitesSiteIdHeatmapRouteImport } from './routes/_authenticated/sites/$siteId/heatmap'
import { Route as AuthenticatedSitesSiteIdSessionsIndexRouteImport } from './routes/_authenticated/sites/$siteId/sessions/index'
import { Route as AuthenticatedSitesSiteIdSessionsSessionIdRouteImport } from './routes/_authenticated/sites/$siteId/sessions/$sessionId'

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedAdminRouteRoute = AuthenticatedAdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSitesIndexRoute = AuthenticatedSitesIndexRouteImport.update({
  id: '/sites/',
  path: '/sites/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSitesNewRoute = AuthenticatedSitesNewRouteImport.update({
  id: '/sites/new',
  path: '/sites/new',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAdminSystemRoute =
  AuthenticatedAdminSystemRouteImport.update({
    id: '/system',
    path: '/system',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminMembersRoute =
  AuthenticatedAdminMembersRouteImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () => AuthenticatedAdminRouteRoute,
  } as any)
const AuthenticatedAdminAuditRoute = AuthenticatedAdminAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AuthenticatedAdminRouteRoute,
} as any)
const AuthenticatedSitesSiteIdRouteRoute =
  AuthenticatedSitesSiteIdRouteRouteImport.update({
    id: '/sites/$siteId',
    path: '/sites/$siteId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSitesSiteIdIndexRoute =
  AuthenticatedSitesSiteIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSitesSiteIdRouteRoute,
  } as any)
const AuthenticatedSitesSiteIdInsightsRoute =
  AuthenticatedSitesSiteIdInsightsRouteImport.update({
    id: '/insights',
    path: '/insights',
    getParentRoute: () => AuthenticatedSitesSiteIdRouteRoute,
  } as any)
const AuthenticatedSitesSiteIdHeatmapRoute =
  AuthenticatedSitesSiteIdHeatmapRouteImport.update({
    id: '/heatmap',
    path: '/heatmap',
    getParentRoute: () => AuthenticatedSitesSiteIdRouteRoute,
  } as any)
const AuthenticatedSitesSiteIdSessionsIndexRoute =
  AuthenticatedSitesSiteIdSessionsIndexRouteImport.update({
    id: '/sessions/',
    path: '/sessions/',
    getParentRoute: () => AuthenticatedSitesSiteIdRouteRoute,
  } as any)
const AuthenticatedSitesSiteIdSessionsSessionIdRoute =
  AuthenticatedSitesSiteIdSessionsSessionIdRouteImport.update({
    id: '/sessions/$sessionId',
    path: '/sessions/$sessionId',
    getParentRoute: () => AuthenticatedSitesSiteIdRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AuthenticatedAdminRouteRouteWithChildren
  '/sites/$siteId': typeof AuthenticatedSitesSiteIdRouteRouteWithChildren
  '/admin/audit': typeof AuthenticatedAdminAuditRoute
  '/admin/members': typeof AuthenticatedAdminMembersRoute
  '/admin/system': typeof AuthenticatedAdminSystemRoute
  '/sites/new': typeof AuthenticatedSitesNewRoute
  '/sites/': typeof AuthenticatedSitesIndexRoute
  '/sites/$siteId/heatmap': typeof AuthenticatedSitesSiteIdHeatmapRoute
  '/sites/$siteId/insights': typeof AuthenticatedSitesSiteIdInsightsRoute
  '/sites/$siteId/': typeof AuthenticatedSitesSiteIdIndexRoute
  '/sites/$siteId/sessions/$sessionId': typeof AuthenticatedSitesSiteIdSessionsSessionIdRoute
  '/sites/$siteId/sessions/': typeof AuthenticatedSitesSiteIdSessionsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AuthenticatedAdminRouteRouteWithChildren
  '/admin/audit': typeof AuthenticatedAdminAuditRoute
  '/admin/members': typeof AuthenticatedAdminMembersRoute
  '/admin/system': typeof AuthenticatedAdminSystemRoute
  '/sites/new': typeof AuthenticatedSitesNewRoute
  '/sites': typeof AuthenticatedSitesIndexRoute
  '/sites/$siteId/heatmap': typeof AuthenticatedSitesSiteIdHeatmapRoute
  '/sites/$siteId/insights': typeof AuthenticatedSitesSiteIdInsightsRoute
  '/sites/$siteId': typeof AuthenticatedSitesSiteIdIndexRoute
  '/sites/$siteId/sessions/$sessionId': typeof AuthenticatedSitesSiteIdSessionsSessionIdRoute
  '/sites/$siteId/sessions': typeof AuthenticatedSitesSiteIdSessionsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_authenticated/admin': typeof AuthenticatedAdminRouteRouteWithChildren
  '/_authenticated/sites/$siteId': typeof AuthenticatedSitesSiteIdRouteRouteWithChildren
  '/_authenticated/admin/audit': typeof AuthenticatedAdminAuditRoute
  '/_authenticated/admin/members': typeof AuthenticatedAdminMembersRoute
  '/_authenticated/admin/system': typeof AuthenticatedAdminSystemRoute
  '/_authenticated/sites/new': typeof AuthenticatedSitesNewRoute
  '/_authenticated/sites/': typeof AuthenticatedSitesIndexRoute
  '/_authenticated/sites/$siteId/heatmap': typeof AuthenticatedSitesSiteIdHeatmapRoute
  '/_authenticated/sites/$siteId/insights': typeof AuthenticatedSitesSiteIdInsightsRoute
  '/_authenticated/sites/$siteId/': typeof AuthenticatedSitesSiteIdIndexRoute
  '/_authenticated/sites/$siteId/sessions/$sessionId': typeof AuthenticatedSitesSiteIdSessionsSessionIdRoute
  '/_authenticated/sites/$siteId/sessions/': typeof AuthenticatedSitesSiteIdSessionsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/sites/$siteId'
    | '/admin/audit'
    | '/admin/members'
    | '/admin/system'
    | '/sites/new'
    | '/sites/'
    | '/sites/$siteId/heatmap'
    | '/sites/$siteId/insights'
    | '/sites/$siteId/'
    | '/sites/$siteId/sessions/$sessionId'
    | '/sites/$siteId/sessions/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/admin/audit'
    | '/admin/members'
    | '/admin/system'
    | '/sites/new'
    | '/sites'
    | '/sites/$siteId/heatmap'
    | '/sites/$siteId/insights'
    | '/sites/$siteId'
    | '/sites/$siteId/sessions/$sessionId'
    | '/sites/$siteId/sessions'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/_authenticated/admin'
    | '/_authenticated/sites/$siteId'
    | '/_authenticated/admin/audit'
    | '/_authenticated/admin/members'
    | '/_authenticated/admin/system'
    | '/_authenticated/sites/new'
    | '/_authenticated/sites/'
    | '/_authenticated/sites/$siteId/heatmap'
    | '/_authenticated/sites/$siteId/insights'
    | '/_authenticated/sites/$siteId/'
    | '/_authenticated/sites/$siteId/sessions/$sessionId'
    | '/_authenticated/sites/$siteId/sessions/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/admin': {
      id: '/_authenticated/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthenticatedAdminRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/sites/': {
      id: '/_authenticated/sites/'
      path: '/sites'
      fullPath: '/sites/'
      preLoaderRoute: typeof AuthenticatedSitesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/sites/new': {
      id: '/_authenticated/sites/new'
      path: '/sites/new'
      fullPath: '/sites/new'
      preLoaderRoute: typeof AuthenticatedSitesNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/system': {
      id: '/_authenticated/admin/system'
      path: '/system'
      fullPath: '/admin/system'
      preLoaderRoute: typeof AuthenticatedAdminSystemRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/members': {
      id: '/_authenticated/admin/members'
      path: '/members'
      fullPath: '/admin/members'
      preLoaderRoute: typeof AuthenticatedAdminMembersRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/admin/audit': {
      id: '/_authenticated/admin/audit'
      path: '/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof AuthenticatedAdminAuditRouteImport
      parentRoute: typeof AuthenticatedAdminRouteRoute
    }
    '/_authenticated/sites/$siteId': {
      id: '/_authenticated/sites/$siteId'
      path: '/sites/$siteId'
      fullPath: '/sites/$siteId'
      preLoaderRoute: typeof AuthenticatedSitesSiteIdRouteRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/sites/$siteId/': {
      id: '/_authenticated/sites/$siteId/'
      path: '/'
      fullPath: '/sites/$siteId/'
      preLoaderRoute: typeof AuthenticatedSitesSiteIdIndexRouteImport
      parentRoute: typeof AuthenticatedSitesSiteIdRouteRoute
    }
    '/_authenticated/sites/$siteId/insights': {
      id: '/_authenticated/sites/$siteId/insights'
      path: '/insights'
      fullPath: '/sites/$siteId/insights'
      preLoaderRoute: typeof AuthenticatedSitesSiteIdInsightsRouteImport
      parentRoute: typeof AuthenticatedSitesSiteIdRouteRoute
    }
    '/_authenticated/sites/$siteId/heatmap': {
      id: '/_authenticated/sites/$siteId/heatmap'
      path: '/heatmap'
      fullPath: '/sites/$siteId/heatmap'
      preLoaderRoute: typeof AuthenticatedSitesSiteIdHeatmapRouteImport
      parentRoute: typeof AuthenticatedSitesSiteIdRouteRoute
    }
    '/_authenticated/sites/$siteId/sessions/': {
      id: '/_authenticated/sites/$siteId/sessions/'
      path: '/sessions'
      fullPath: '/sites/$siteId/sessions/'
      preLoaderRoute: typeof AuthenticatedSitesSiteIdSessionsIndexRouteImport
      parentRoute: typeof AuthenticatedSitesSiteIdRouteRoute
    }
    '/_authenticated/sites/$siteId/sessions/$sessionId': {
      id: '/_authenticated/sites/$siteId/sessions/$sessionId'
      path: '/sessions/$sessionId'
      fullPath: '/sites/$siteId/sessions/$sessionId'
      preLoaderRoute: typeof AuthenticatedSitesSiteIdSessionsSessionIdRouteImport
      parentRoute: typeof AuthenticatedSitesSiteIdRouteRoute
    }
  }
}

interface AuthenticatedAdminRouteRouteChildren {
  AuthenticatedAdminAuditRoute: typeof AuthenticatedAdminAuditRoute
  AuthenticatedAdminMembersRoute: typeof AuthenticatedAdminMembersRoute
  AuthenticatedAdminSystemRoute: typeof AuthenticatedAdminSystemRoute
}

const AuthenticatedAdminRouteRouteChildren: AuthenticatedAdminRouteRouteChildren =
  {
    AuthenticatedAdminAuditRoute: AuthenticatedAdminAuditRoute,
    AuthenticatedAdminMembersRoute: AuthenticatedAdminMembersRoute,
    AuthenticatedAdminSystemRoute: AuthenticatedAdminSystemRoute,
  }

const AuthenticatedAdminRouteRouteWithChildren =
  AuthenticatedAdminRouteRoute._addFileChildren(
    AuthenticatedAdminRouteRouteChildren,
  )

interface AuthenticatedSitesSiteIdRouteRouteChildren {
  AuthenticatedSitesSiteIdHeatmapRoute: typeof AuthenticatedSitesSiteIdHeatmapRoute
  AuthenticatedSitesSiteIdInsightsRoute: typeof AuthenticatedSitesSiteIdInsightsRoute
  AuthenticatedSitesSiteIdIndexRoute: typeof AuthenticatedSitesSiteIdIndexRoute
  AuthenticatedSitesSiteIdSessionsSessionIdRoute: typeof AuthenticatedSitesSiteIdSessionsSessionIdRoute
  AuthenticatedSitesSiteIdSessionsIndexRoute: typeof AuthenticatedSitesSiteIdSessionsIndexRoute
}

const AuthenticatedSitesSiteIdRouteRouteChildren: AuthenticatedSitesSiteIdRouteRouteChildren =
  {
    AuthenticatedSitesSiteIdHeatmapRoute: AuthenticatedSitesSiteIdHeatmapRoute,
    AuthenticatedSitesSiteIdInsightsRoute:
      AuthenticatedSitesSiteIdInsightsRoute,
    AuthenticatedSitesSiteIdIndexRoute: AuthenticatedSitesSiteIdIndexRoute,
    AuthenticatedSitesSiteIdSessionsSessionIdRoute:
      AuthenticatedSitesSiteIdSessionsSessionIdRoute,
    AuthenticatedSitesSiteIdSessionsIndexRoute:
      AuthenticatedSitesSiteIdSessionsIndexRoute,
  }

const AuthenticatedSitesSiteIdRouteRouteWithChildren =
  AuthenticatedSitesSiteIdRouteRoute._addFileChildren(
    AuthenticatedSitesSiteIdRouteRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedAdminRouteRoute: typeof AuthenticatedAdminRouteRouteWithChildren
  AuthenticatedSitesSiteIdRouteRoute: typeof AuthenticatedSitesSiteIdRouteRouteWithChildren
  AuthenticatedSitesNewRoute: typeof AuthenticatedSitesNewRoute
  AuthenticatedSitesIndexRoute: typeof AuthenticatedSitesIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAdminRouteRoute: AuthenticatedAdminRouteRouteWithChildren,
  AuthenticatedSitesSiteIdRouteRoute:
    AuthenticatedSitesSiteIdRouteRouteWithChildren,
  AuthenticatedSitesNewRoute: AuthenticatedSitesNewRoute,
  AuthenticatedSitesIndexRoute: AuthenticatedSitesIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
